<template>
  <span class="svg-ico-stem">
    <svg
      class="icon-color-1"
      :style="`width:${width}px;height:${width}px;fill:none;`"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.7263 17.9165L2 21.0657H21.8159L20.0896 17.9165"
        :stroke="color"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.2462 5.37232L11.907 2.93457L9.05078 8.15533"
        :stroke="color"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.53689 10.7495C5.88215 10.7495 6.16463 11.032 6.16463 11.3773C6.16463 11.6911 5.93446 11.9527 5.63105 11.9945H5.54735H3.99891C3.89428 11.9945 3.78966 12.0364 3.70596 12.1201C3.63272 12.1933 3.58041 12.298 3.58041 12.413C3.58041 12.6118 3.72688 12.7792 3.91521 12.8211H3.98844H4.82544C5.70428 12.8211 6.41573 13.5011 6.47851 14.3591V14.4951C6.47851 15.3739 5.80891 16.0854 4.95099 16.1481H4.82544H3.06775C2.72249 16.1481 2.44 15.8656 2.44 15.5204C2.44 15.2065 2.67018 14.945 2.97359 14.9031H3.05729H4.81498C5.01376 14.9031 5.18116 14.7566 5.22301 14.5683V14.4846C5.22301 14.2858 5.087 14.1184 4.88821 14.0766H4.81498H3.97798C3.05729 14.0766 2.31445 13.3337 2.31445 12.4235C2.31445 11.9841 2.49231 11.5656 2.79573 11.2517C3.06775 10.9797 3.43393 10.8018 3.82104 10.7704H3.96752H5.51596L5.53689 10.7495Z"
        :fill="color"
      />
      <path
        d="M9.73232 11.9627H6.92839C6.60405 11.9627 6.33203 11.7012 6.33203 11.3664C6.33203 11.0316 6.60405 10.77 6.92839 10.77H9.73232C10.0567 10.77 10.3287 11.0316 10.3287 11.3664C10.3287 11.7012 10.0567 11.9627 9.73232 11.9627Z"
        :fill="color"
      />
      <path
        d="M8.32878 16.127C8.00445 16.127 7.73242 15.8654 7.73242 15.5306V11.3561C7.73242 11.0318 8.00445 10.7598 8.32878 10.7598C8.65312 10.7598 8.92514 11.0213 8.92514 11.3561V15.5306C8.92514 15.855 8.65312 16.127 8.32878 16.127Z"
        :fill="color"
      />
      <path
        d="M14.1249 11.9627H11.321C10.9966 11.9627 10.7246 11.7012 10.7246 11.3664C10.7246 11.0316 10.9966 10.77 11.321 10.77H14.1249C14.4492 10.77 14.7213 11.0316 14.7213 11.3664C14.7213 11.7012 14.4492 11.9627 14.1249 11.9627Z"
        :fill="color"
      />
      <path
        d="M13.2142 14.0453H12.9108C12.5865 14.0453 12.3145 13.7837 12.3145 13.4489C12.3145 13.1141 12.5865 12.8525 12.9108 12.8525H13.2142C13.5386 12.8525 13.8106 13.1141 13.8106 13.4489C13.8106 13.7837 13.5386 14.0453 13.2142 14.0453Z"
        :fill="color"
      />
      <path
        d="M14.1249 16.1273H11.321C10.9966 16.1273 10.7246 15.8657 10.7246 15.5309C10.7246 15.1961 10.9966 14.9346 11.321 14.9346H14.1249C14.4492 14.9346 14.7213 15.1961 14.7213 15.5309C14.7213 15.8657 14.4492 16.1273 14.1249 16.1273Z"
        :fill="color"
      />
      <path
        d="M11.321 16.127C10.9966 16.127 10.7246 15.8654 10.7246 15.5306V11.3561C10.7246 11.0318 10.9966 10.7598 11.321 10.7598C11.6453 10.7598 11.9173 11.0213 11.9173 11.3561V15.5306C11.9173 15.855 11.6453 16.127 11.321 16.127Z"
        :fill="color"
      />
      <path
        d="M18.9204 16.1271C18.617 16.1271 18.345 15.9492 18.2299 15.6667L16.6292 11.8165C16.4722 11.4294 16.6501 10.99 17.0372 10.8331C17.1314 10.7912 17.2255 10.7808 17.3302 10.7808C17.6336 10.7808 17.9056 10.9586 18.0207 11.2411L19.6214 15.0913C19.7784 15.4784 19.6005 15.9178 19.2134 16.0748C19.1192 16.1166 19.0251 16.1271 18.9204 16.1271Z"
        :fill="color"
      />
      <path
        d="M21.2427 16.1271C20.9393 16.1271 20.6673 15.9492 20.5522 15.6667L18.9514 11.8165C18.7945 11.4294 18.9724 10.99 19.3595 10.8331C19.4536 10.7912 19.5478 10.7808 19.6524 10.7808C19.9558 10.7808 20.2279 10.9586 20.3429 11.2411L21.9437 15.0913C22.1006 15.4679 21.9228 15.9178 21.5357 16.0748C21.4415 16.1166 21.3473 16.1271 21.2427 16.1271Z"
        :fill="color"
      />
      <path
        d="M15.8653 16.1271C15.7711 16.1271 15.6665 16.1062 15.5724 16.0748C15.1853 15.9179 15.0074 15.4784 15.1643 15.0913L15.6247 13.9823C15.7398 13.6998 16.0118 13.522 16.3152 13.522C16.4094 13.522 16.514 13.5429 16.6081 13.5743C16.9953 13.7312 17.1731 14.1706 17.0162 14.5578L16.5558 15.6668C16.4407 15.9493 16.1687 16.1271 15.8653 16.1271Z"
        :fill="color"
      />
      <path
        d="M19.3359 6.86816V9.48377"
        :stroke="color"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.643 8.17627H18.0273"
        :stroke="color"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.1211 6.86816V9.48377"
        :stroke="color"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.4301 8.17627H13.8145"
        :stroke="color"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
